const initialState = {
  lists: {
    error: null,
    datos: [],
    loading: false,
    status: null,
    selected: {
      listId:null,
      listName: ""
    }
  },
  listCreate: {
    error: null,
    datos: {},
    loading: false,
    status: null,
  },
  listDelete: {
    error: null,
    datos: {},
    loading: false,
    status: null,
  },
  items: {
    loading: false,
    error: null,
    status: null,
    datos: [],
    newDataToSave:false
  },
  itemsChanges: {
    datos: [],
    loading: false,
    error: null,
    status: null,
    itemsNotSaved: []
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/account_list/initialState.js